(() => {
  const propertySelector = 'input[name="properties[カラー]"]';
  const wrapperSelector = '[data-white-tee-special-price-wrapper]';

  const isWhiteSelected = () =>
    Array.from(document.querySelectorAll(propertySelector)).some(
      (input) => input.checked && input.value.trim().toLowerCase() === 'white',
    );

  const syncPrice = () => {
    const active = isWhiteSelected();

    document.querySelectorAll(wrapperSelector).forEach((wrapper) => {
      const specialPrice = wrapper.querySelector('[data-white-tee-special-price]');
      if (!specialPrice) return;

      wrapper.classList.toggle('is-white-tee-special-active', active);
      specialPrice.hidden = !active;
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches?.(propertySelector)) syncPrice();
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches?.(propertySelector)) syncPrice();
  });

  document.addEventListener('shopify:section:load', syncPrice);

  const observer = new MutationObserver(syncPrice);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['checked', 'value', 'aria-checked'],
  });

  window.setInterval(syncPrice, 500);
  syncPrice();
})();
